import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import HELPERS from '../../utils/helper';
import { ToastMessage, Toast, toastMsgConfig } from '../toast';
import apis from '../../config/apis';
import { ErrorMessageHandling } from '../error';
import { getClientConfig } from '../../config/clientConfig';
import './template13.css';

// IIG Mumbai Template - Simple Enquiry Form
class EnquiryTemplate14 extends Component {
  constructor(props) {
    super(props);

    const clientConfig = getClientConfig(props.clientId);

    if (!clientConfig) {
      this.state = {
        loader: false,
        clientConfig: null,
        formData: {},
        errors: {},
        disabled: true,
        areas: [],
        courses: [],
      };
      return;
    }

    this.state = {
      loader: false,
      formData: {
        name: '',
        phone: '',
        email: '',
        state: '',
        city: '',
        area: '',
        program: '',
        areaOfInterest: '',
        preferMode: '',
        preferTime: ''
      },
      errors: {},
      disabled: false,
      areas: [],
      states: [],
      cities: [],
      clientConfig: clientConfig,
      courses: clientConfig.courses || []
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.fetchStates();
    this.fetchCourses();
  }

  fetchStates = async () => {
    try {
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      const statesUrl = 'https://api.proctur.com/StdMgmtWebAPI/api/v1/country/state?country_ids=1';
      const res = await HELPERS.ApiCall(statesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data && res.data.result) {
        const result = res.data.result;
        const states = [];

        if (Array.isArray(result)) {
          result.forEach(country => {
            if (country.stateList && Array.isArray(country.stateList)) {
              country.stateList.forEach(state => {
                if (state.state_name) {
                  states.push({
                    stateId: state.state_id,
                    stateName: state.state_name
                  });
                }
              });
            }
          });
        }

        if (states.length > 0) {
          this.setState({ states });
        } else {
          this.useFallbackStates();
        }
      } else {
        this.useFallbackStates();
      }
    } catch (err) {
      console.error('Error fetching states:', err);
      this.useFallbackStates();
    }
  }

  useFallbackStates = () => {
    this.setState({
      states: [
        { stateId: 11, stateName: 'Maharashtra' }
      ]
    });
  }

  fetchCities = async (stateId) => {
    try {
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      const citiesUrl = `https://api.proctur.com/StdMgmtWebAPI/api/v1/country/city?state_ids=${stateId}`;
      const res = await HELPERS.ApiCall(citiesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data && res.data.result) {
        const result = res.data.result;
        const cities = [];

        if (Array.isArray(result)) {
          result.forEach(state => {
            if (state.cityList && Array.isArray(state.cityList)) {
              state.cityList.forEach(city => {
                if (city.city_name) {
                  cities.push({
                    cityId: city.city_id,
                    cityName: city.city_name
                  });
                }
              });
            }
          });
        }

        if (cities.length > 0) {
          this.setState({ cities });
        } else {
          this.setState({ cities: [] });
        }
      } else {
        this.setState({ cities: [] });
      }
    } catch (err) {
      console.error('Error fetching cities:', err);
      this.setState({ cities: [] });
    }
  }

  fetchAreas = async (cityId) => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*'
        }
      };

      const areasUrl = `https://api.proctur.com/StdMgmtWebAPI/api/v1/cityArea/area/${clientConfig.instituteId}?city_ids=${cityId}`;
      const res = await HELPERS.ApiCall(areasUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const result = res.data.result || res.data.data || res.data;
        const areas = [];

        if (Array.isArray(result)) {
          result.forEach(item => {
            if (item.areaList && Array.isArray(item.areaList)) {
              item.areaList.forEach(areaObj => {
                if (areaObj.area) {
                  areas.push({
                    areaId: areaObj.id,
                    areaName: areaObj.area
                  });
                }
              });
            }
          });
        }

        if (areas.length > 0) {
          this.setState({ areas });
        } else {
          this.setState({ areas: [] });
        }
      } else {
        this.setState({ areas: [] });
      }
    } catch (err) {
      console.error('Error fetching areas:', err);
      this.setState({ areas: [] });
    }
  }

  fetchCourses = async () => {
    try {
      const { clientConfig } = this.state;
      const headers = {
        headers: {
          'Accept': 'application/json, text/plain, */*',
        }
      };

      const coursesUrl = apis.getCoursesUrl(clientConfig);
      const res = await HELPERS.ApiCall(coursesUrl, {}, 'GET', 'proctur', headers);

      if (res.status === 200 && res.data) {
        const courseList = res.data.data || res.data;
        const courses = [];

        if (Array.isArray(courseList)) {
          courseList.forEach(item => {
            if (item.master_course) {
              courses.push(item.master_course);
            }
          });
        }

        if (courses.length > 0) {
          this.setState({ courses });
        } else {
          this.useFallbackCourses();
        }
      } else {
        this.useFallbackCourses();
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
      this.useFallbackCourses();
    }
  }

  useFallbackCourses = () => {
    const { clientConfig } = this.state;
    if (clientConfig && clientConfig.courses) {
      this.setState({ courses: clientConfig.courses });
    }
  }

  showMessage = (type, message) => {
    Toast(message, toastMsgConfig(type));
  }

  handleInputChange = (field, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value
      },
      errors: {
        ...this.state.errors,
        [field]: ''
      }
    });
  }

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    } else if (formData.name.trim().length < 2) {
      errors.name = 'Name must be at least 2 characters';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone.replace(/\s/g, ''))) {
      errors.phone = 'Please enter a valid 10-digit phone number';
    }

    if (!formData.email.trim()) {
      errors.email = 'Email address is required';
    } else if (!HELPERS.validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!formData.state) {
      errors.state = 'Please select a state';
    }

    if (!formData.city) {
      errors.city = 'Please select a city';
    }

    if (!formData.program) {
      errors.program = 'Please select a program';
    }

    if (!formData.areaOfInterest) {
      errors.areaOfInterest = 'Please select area of interest';
    }

    if (!formData.preferMode) {
      errors.preferMode = 'Please select preferred mode';
    }

    if (!formData.preferTime) {
      errors.preferTime = 'Please select preferred time';
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  }

  handleSubmit = async () => {
    this.setState({ disabled: true });

    if (!HELPERS.checkRateLimit('form_submission', 3, 60000)) {
      this.setState({ disabled: false });
      this.showMessage('e', 'Too many submissions. Please wait a minute before trying again.');
      return;
    }

    if (!this.validateForm()) {
      this.setState({ disabled: false });
      this.showMessage('e', 'Please correct the errors in the form');
      return;
    }

    this.setState({ loader: true });

    try {
      const { clientConfig, formData } = this.state;
      const headers = {
        headers: {
          'Authorization': clientConfig.api.authorization,
          'Content-Type': 'application/json',
          'source': 'WEB',
          'accept': 'application/json, text/plain, */*'
        }
      };

      const customComponentList = [
        {
          label: 'Area of Interest',
          enq_custom_value: formData.areaOfInterest
        },
        {
          label: 'Preferred Mode',
          enq_custom_value: formData.preferMode
        },
        {
          label: 'Preferred Time',
          enq_custom_value: formData.preferTime
        }
      ];

      const payload = {
        name: formData.name,
        mobile: formData.phone,
        email: formData.email,
        comments: '',
        institute_id: clientConfig.instituteId,
        customComponentList: customComponentList,
        mCourseName: formData.program,
        state: formData.state || clientConfig.api.defaults.state,
        city: formData.city || clientConfig.api.defaults.city,
        area: formData.area || clientConfig.api.defaults.defaultArea
      };

      const apiUrl = apis.getApiUrl(clientConfig);
      const res = await HELPERS.ApiCall(apiUrl, payload, 'POST', 'proctur', headers);

      if (res.status === 200 && res.data.statusCode === 200) {
        this.setState({
          loader: false,
          formData: {
            name: '',
            phone: '',
            email: '',
            state: '',
            city: '',
            area: '',
            program: '',
            areaOfInterest: '',
            preferMode: '',
            preferTime: ''
          },
          disabled: false,
          errors: {},
          cities: [],
          areas: []
        });
        this.showMessage('s', 'Enquiry submitted successfully! Our team will contact you soon.');
      } else {
        this.showMessage('e', res.data.message || 'Something went wrong. Please try again.');
        this.setState({ loader: false, disabled: false });
      }
    } catch (err) {
      if (err.response && err.response.status === 403) {
        this.props.dispatch({
          type: 'LOGOUT',
          message: err.response.data?.message || 'Session expired'
        });
      } else {
        this.showMessage('e', ErrorMessageHandling(err));
      }
      this.setState({ loader: false, disabled: false });
    }
  }

  render() {
    const { formData, errors, disabled, loader, courses, clientConfig } = this.state;

    if (!clientConfig) {
      return null;
    }

    const areaOfInterestOptions = clientConfig.areaOfInterestOptions || [
      'Management',
      'Marketing',
      'Finance',
      'Human Resources',
      'Operations',
      'Business Analytics',
      'Entrepreneurship'
    ];

    const preferModeOptions = clientConfig.preferModeOptions || [
      'Online',
      'Offline',
      'Hybrid'
    ];

    const preferTimeOptions = clientConfig.preferTimeOptions || [
      'Morning (9 AM - 12 PM)',
      'Afternoon (12 PM - 4 PM)',
      'Evening (4 PM - 8 PM)'
    ];

    return (
      <>
        {loader && (
          <div className="template13-loader">
            <div className="template13-loading-spinner"></div>
            <p>Submitting your enquiry...</p>
          </div>
        )}
        <ToastMessage />

        <div className="template13-app">
          {/* App Header */}
          <header className="template13-header">
            <div className="template13-header-content">
              <div className="template13-logo-wrapper">
                <div className="template13-logo">
                  <img src={clientConfig.branding.logo} alt={clientConfig.clientName} />
                </div>
                <div className="template13-header-info">
                  <h1>{clientConfig.clientName}</h1>
                  <p className="template13-subtitle">{clientConfig.branding.heroSubtitle}</p>
                </div>
              </div>
              <span className="template13-badge">{clientConfig.branding.badgeText}</span>
            </div>
          </header>

          {/* Main Content Container */}
          <div className="template13-content">
            {/* Enquiry Form Card */}
            <div className="template13-form-card">
              <div className="template13-form-header">
                <h2>Enquiry Form</h2>
                <p>Fill in your details and we'll get back to you</p>
              </div>

              <form className="template13-form" onSubmit={(e) => e.preventDefault()}>
                {/* Personal Information Section */}
                <div className="template13-section">
                  <div className="template13-section-header">
                    <h3><i className="fa fa-user"></i> Personal Information</h3>
                  </div>
                  <div className="template13-input-grid">
                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-user"></i>
                        Name <span className="template13-required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`template13-input ${errors.name ? 'template13-error' : ''} ${formData.name ? 'template13-filled' : ''}`}
                        placeholder="Enter your full name"
                        value={formData.name}
                        onChange={(e) => this.handleInputChange('name', e.target.value)}
                      />
                      {errors.name && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.name}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-phone"></i>
                        Phone <span className="template13-required">*</span>
                      </label>
                      <input
                        type="tel"
                        className={`template13-input ${errors.phone ? 'template13-error' : ''} ${formData.phone ? 'template13-filled' : ''}`}
                        placeholder="10-digit phone number"
                        value={formData.phone}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          if (value.length <= 10) {
                            this.handleInputChange('phone', value);
                          }
                        }}
                      />
                      {errors.phone && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.phone}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-envelope"></i>
                        Email <span className="template13-required">*</span>
                      </label>
                      <input
                        type="email"
                        className={`template13-input ${errors.email ? 'template13-error' : ''} ${formData.email ? 'template13-filled' : ''}`}
                        placeholder="your@email.com"
                        value={formData.email}
                        onChange={(e) => this.handleInputChange('email', e.target.value)}
                      />
                      {errors.email && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.email}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Location Section */}
                <div className="template13-section">
                  <div className="template13-section-header">
                    <h3><i className="fa fa-map-marker-alt"></i> Location</h3>
                  </div>
                  <div className="template13-input-grid">
                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-map"></i>
                        State <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.state ? 'template13-error' : ''} ${formData.state ? 'template13-filled' : ''}`}
                        value={formData.state}
                        onChange={(e) => {
                          const selectedState = this.state.states.find(s => s.stateName === e.target.value);
                          const newFormData = { ...this.state.formData, state: e.target.value, city: '', area: '' };
                          this.setState({ formData: newFormData, cities: [], areas: [] });
                          if (selectedState) {
                            this.fetchCities(selectedState.stateId);
                          }
                        }}
                      >
                        <option value="">Select state</option>
                        {this.state.states.map((state, index) => (
                          <option key={index} value={state.stateName}>{state.stateName}</option>
                        ))}
                      </select>
                      {errors.state && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.state}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-city"></i>
                        City <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.city ? 'template13-error' : ''} ${formData.city ? 'template13-filled' : ''}`}
                        value={formData.city}
                        onChange={(e) => {
                          const selectedCity = this.state.cities.find(c => c.cityName === e.target.value);
                          const newFormData = { ...this.state.formData, city: e.target.value, area: '' };
                          this.setState({ formData: newFormData, areas: [] });
                          if (selectedCity) {
                            this.fetchAreas(selectedCity.cityId);
                          }
                        }}
                        disabled={!formData.state || this.state.cities.length === 0}
                      >
                        <option value="">Select city</option>
                        {this.state.cities.map((city, index) => (
                          <option key={index} value={city.cityName}>{city.cityName}</option>
                        ))}
                      </select>
                      {errors.city && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.city}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-map-pin"></i>
                        Area
                      </label>
                      <select
                        className={`template13-input template13-select ${formData.area ? 'template13-filled' : ''}`}
                        value={formData.area}
                        onChange={(e) => this.handleInputChange('area', e.target.value)}
                        disabled={!formData.city || this.state.areas.length === 0}
                      >
                        <option value="">Select area</option>
                        {this.state.areas.map((area, index) => (
                          <option key={index} value={area.areaName}>{area.areaName}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Program Information Section */}
                <div className="template13-section">
                  <div className="template13-section-header">
                    <h3><i className="fa fa-graduation-cap"></i> Program Information</h3>
                  </div>
                  <div className="template13-input-grid">
                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-book"></i>
                        Select Program <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.program ? 'template13-error' : ''} ${formData.program ? 'template13-filled' : ''}`}
                        value={formData.program}
                        onChange={(e) => this.handleInputChange('program', e.target.value)}
                      >
                        <option value="">Choose a program</option>
                        {courses.map((course, index) => (
                          <option key={index} value={course}>{course}</option>
                        ))}
                      </select>
                      {errors.program && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.program}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group template13-full-width">
                      <label className="template13-label">
                        <i className="fa fa-lightbulb"></i>
                        Area of Interest <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.areaOfInterest ? 'template13-error' : ''} ${formData.areaOfInterest ? 'template13-filled' : ''}`}
                        value={formData.areaOfInterest}
                        onChange={(e) => this.handleInputChange('areaOfInterest', e.target.value)}
                      >
                        <option value="">Select area of interest</option>
                        {areaOfInterestOptions.map((option, index) => (
                          <option key={index} value={option}>{option}</option>
                        ))}
                      </select>
                      {errors.areaOfInterest && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.areaOfInterest}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-laptop"></i>
                        Preferred Mode <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.preferMode ? 'template13-error' : ''} ${formData.preferMode ? 'template13-filled' : ''}`}
                        value={formData.preferMode}
                        onChange={(e) => this.handleInputChange('preferMode', e.target.value)}
                      >
                        <option value="">Select mode</option>
                        {preferModeOptions.map((option, index) => (
                          <option key={index} value={option}>{option}</option>
                        ))}
                      </select>
                      {errors.preferMode && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.preferMode}
                        </span>
                      )}
                    </div>

                    <div className="template13-input-group">
                      <label className="template13-label">
                        <i className="fa fa-clock"></i>
                        Preferred Time <span className="template13-required">*</span>
                      </label>
                      <select
                        className={`template13-input template13-select ${errors.preferTime ? 'template13-error' : ''} ${formData.preferTime ? 'template13-filled' : ''}`}
                        value={formData.preferTime}
                        onChange={(e) => this.handleInputChange('preferTime', e.target.value)}
                      >
                        <option value="">Select time</option>
                        {preferTimeOptions.map((option, index) => (
                          <option key={index} value={option}>{option}</option>
                        ))}
                      </select>
                      {errors.preferTime && (
                        <span className="template13-error-text">
                          <i className="fa fa-exclamation-circle"></i> {errors.preferTime}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="template13-submit-wrapper">
                  <button
                    type="button"
                    className={`template13-submit-btn ${disabled ? 'template13-disabled' : ''}`}
                    onClick={this.handleSubmit}
                    disabled={disabled}
                  >
                    {loader ? (
                      <>
                        <i className="fa fa-spinner fa-spin"></i>
                        <span>Submitting...</span>
                      </>
                    ) : (
                      <>
                        <i className="fa fa-paper-plane"></i>
                        <span>Submit Enquiry</span>
                        <i className="fa fa-arrow-right"></i>
                      </>
                    )}
                  </button>

                  <div className="template13-form-footer">
                    <i className="fa fa-lock"></i>
                    <span>Your information is secure and will be kept confidential</span>
                  </div>
                </div>
              </form>
            </div>

            {/* Contact Info Card */}
            <div className="template13-sidebar">
              <div className="template13-contact-card">
                <h3>
                  <i className="fa fa-headset"></i>
                  Contact Information
                </h3>
                <div className="template13-contact-list">
                  <a href={`tel:${clientConfig.contactInfo.phone1}`} className="template13-contact-item">
                    <div className="template13-contact-icon">
                      <i className="fa fa-phone"></i>
                    </div>
                    <div className="template13-contact-details">
                      <span className="template13-contact-label">Call Us</span>
                      <span className="template13-contact-value">{clientConfig.contactInfo.phone1}</span>
                    </div>
                    <i className="fa fa-chevron-right template13-contact-arrow"></i>
                  </a>

                  <a href={`mailto:${clientConfig.contactInfo.email}`} className="template13-contact-item">
                    <div className="template13-contact-icon">
                      <i className="fa fa-envelope"></i>
                    </div>
                    <div className="template13-contact-details">
                      <span className="template13-contact-label">Email Us</span>
                      <span className="template13-contact-value">{clientConfig.contactInfo.email}</span>
                    </div>
                    <i className="fa fa-chevron-right template13-contact-arrow"></i>
                  </a>

                  <div className="template13-contact-item template13-address-item">
                    <div className="template13-contact-icon">
                      <i className="fa fa-map-marker-alt"></i>
                    </div>
                    <div className="template13-contact-details">
                      <span className="template13-contact-label">Visit Us</span>
                      <span className="template13-contact-value">{clientConfig.contactInfo.address}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Navigation (Mobile) */}
          <div className="template13-bottom-nav">
            <a href={`tel:${clientConfig.contactInfo.phone1}`} className="template13-nav-item">
              <i className="fa fa-phone-alt"></i>
              <span>Call</span>
            </a>
            <a href={`mailto:${clientConfig.contactInfo.email}`} className="template13-nav-item">
              <i className="fa fa-envelope"></i>
              <span>Email</span>
            </a>
            <a href={`https://${clientConfig.contactInfo.website}`} target="_blank" rel="noopener noreferrer" className="template13-nav-item">
              <i className="fa fa-globe"></i>
              <span>Website</span>
            </a>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.home,
  ...state.auth
});

const ConnectedEnquiryTemplate14 = connect(mapStateToProps)(EnquiryTemplate14);

function EnquiryTemplate14WithRouter(props) {
  const { clientId } = useParams();
  return <ConnectedEnquiryTemplate14 {...props} clientId={clientId} />;
}

export default EnquiryTemplate14WithRouter;
